import { useEffect } from 'react';
import { X } from 'lucide-react';

/** @param {{ open: boolean; onClose: () => void; src: string | null; mediaType: 'image' | 'video' }} props */
export function FullscreenMediaOverlay({ open, onClose, src, mediaType }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open || !src) return null;

  return (
    <div className="fixed inset-0 z-[220] touch-none" role="presentation">
      <button
        type="button"
        aria-label="Close"
        className="absolute inset-0 bg-black/90"
        onClick={onClose}
      />
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center p-4 pt-14">
        <button
          type="button"
          aria-label="Close"
          className="pointer-events-auto absolute right-3 top-3 z-10 rounded-full bg-black/60 p-2 text-white backdrop-blur-sm hover:bg-black/75"
          onClick={onClose}
        >
          <X size={22} strokeWidth={2} />
        </button>
        <div
          className="pointer-events-auto relative flex max-h-[calc(100vh-6rem)] max-w-[calc(100vw-2rem)] flex-col items-center justify-center touch-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {mediaType === 'video' ? (
            <video src={src} controls autoPlay className="max-h-[calc(100vh-7rem)] max-w-full rounded-lg shadow-lg" playsInline />
          ) : (
            <img src={src} alt="" className="max-h-[calc(100vh-7rem)] max-w-full object-contain rounded-lg shadow-lg" />
          )}
        </div>
      </div>
    </div>
  );
}
